import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import {
  EntityMediaItem,
  EntityMediaResponse,
  MediaItem,
  UserItem,
  UserItemMinimal,
  UserListResponse,
  UserStatsResponse,
} from '../../../api/models';
import { UserControllerFind$Params } from '../../../api/fn/user/user-controller-find';
import { UserControllerUpdate$Params } from '../../../api/fn/user/user-controller-update';
import { UserControllerCreate$Params } from '../../../api/fn/user/user-controller-create';
import { UserControllerUploadPicture$Params } from '../../../api/fn/user/user-controller-upload-picture';
import { UserControllerDelete$Params } from '../../../api/fn/user/user-controller-delete';
import { EntityMediaControllerGetEntityFiles$Params } from '../../../api/fn/file-manager-entita/entity-media-controller-get-entity-files';
import { EntityMediaControllerDetach$Params } from '../../../api/fn/file-manager-entita/entity-media-controller-detach';
import { UserControllerUpdateCredentials$Params } from '../../../api/functions';

export const usersActions = {
  load: createAction('load/users/load', props<UserControllerFind$Params>()),
  done: createAction(
    'load/users/done',
    props<{ state: ILoaderActionPayload; data?: UserListResponse; request?: UserControllerFind$Params }>(),
  ),
  loadOne: createAction('load/users/load-one', props<{ id: number }>()),
  doneOne: createAction('load/users/done-one', props<{ state: ILoaderActionPayload; data?: UserItem }>()),
  loadOneSetState: createAction('users/load-one/state', props<{ state: ILoaderActionPayload }>()),
  loadOneMedia: createAction('users/load-media', props<EntityMediaControllerGetEntityFiles$Params>()),
  loadOneMediaDone: createAction(
    'users/load-media/done',
    props<{
      state: ILoaderActionPayload;
      data?: EntityMediaResponse;
    }>(),
  ),
  loadOneMediaSetState: createAction('users/load-media/state', props<{ state: ILoaderActionPayload }>()),
  deleteOneMedia: createAction('users/delete-media', props<EntityMediaControllerDetach$Params>()),
  deleteOneMediaDone: createAction(
    'users/delete-media/done',
    props<{
      state: ILoaderActionPayload;
      data?: EntityMediaItem;
      entity_id: number;
    }>(),
  ),
  deleteOneMediaSetState: createAction('users/delete-media/state', props<{ state: ILoaderActionPayload }>()),
  saveOne: createAction('users/save-one', props<UserControllerUpdate$Params>()),
  saveOneDone: createAction('users/save-one/done', props<{ state: ILoaderActionPayload; data?: UserItem }>()),
  saveOneSetState: createAction('users/save-one/state', props<{ state: ILoaderActionPayload }>()),
  createOne: createAction('users/create-one', props<UserControllerCreate$Params>()),
  createOneDone: createAction('users/create-one/done', props<{ state: ILoaderActionPayload; data?: UserItem }>()),
  createOneSetState: createAction('users/create-one/state', props<{ state: ILoaderActionPayload }>()),
  uploadAvatar: createAction('users/update-avatar', props<UserControllerUploadPicture$Params>()),
  uploadAvatarDone: createAction('users/update-avatar/done', props<{ state: ILoaderActionPayload; data?: UserItem }>()),
  uploadAvatarFail: createAction('users/update-avatar/fail', props<{ state: ILoaderActionPayload }>()),
  uploadAvatarSetState: createAction('users/update-avatar/state', props<{ state: ILoaderActionPayload }>()),
  deleteOne: createAction('users/delete-one', props<UserControllerDelete$Params>()),
  deleteOneDone: createAction(
    'users/delete-one/done',
    props<{ state: ILoaderActionPayload; data?: UserItemMinimal }>(),
  ),
  deleteOneSetState: createAction('users/delete-one/state', props<{ state: ILoaderActionPayload }>()),
  updateCredentials: createAction('users/update-credentials', props<UserControllerUpdateCredentials$Params>()),
  updateCredentialsDone: createAction(
    'users/update-credentials/done',
    props<{ state: ILoaderActionPayload; data?: UserItem }>(),
  ),
  updateCredentialsSetState: createAction('users/update-credentials/state', props<{ state: ILoaderActionPayload }>()),
};
